var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c(
        "LoginCard",
        {
          key: "confirmation",
          staticClass: "email-sent-content",
          attrs: { header: "Admin TOTP Reset Request" },
        },
        [
          _c("h5", { class: _vm.$style.subheader }, [
            _vm._v("\n      You have requested a TOTP reset.\n    "),
          ]),
          _vm._v(" "),
          _c("ul", { class: _vm.$style.directionsList }, [
            _c("li", { class: _vm.$style.directions }, [
              _vm._v(
                "\n        A confirmation email has been sent (email address must be registered with JumpCloud).\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$style.directions }, [
              _vm._v(
                "\n        Please follow the instructions in the email to reset your TOTP.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$style.directions }, [
              _vm._v(
                "\n        Allow up to 10 minutes for the email to arrive in your inbox.\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("LoginActionButton", { attrs: { action: _vm.goToLogin } }, [
            _vm._v("\n      Return to Login\n    "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }